import { toast } from '@approvalmax/ui/src/components';
import { useDispatch } from 'modules/react-redux';
import { memo, useCallback } from 'react';
import { TwoFaActionWizard } from 'shared/components';
import { useFinishTFALogin, useSendLoginTFAEmailCode } from 'shared/data/webApp/v1';

import { pageConfig } from '../../../config';
import { finishLoginFlow, showLoginModule } from '../../actions';
import { messages } from './LoginTwoFaModule.messages';
import { LoginTwoFaModuleProps } from './LoginTwoFaModule.types';

export const LoginTwoFaModule = memo<LoginTwoFaModuleProps>((props) => {
    const {
        app,
        stateId,
        postAction,
        isTrustThisDeviceEnabled,
        isTFAAlternativeEmailEnabled,
        isTFABackupCodesEnabled,
    } = props;

    const dispatch = useDispatch();

    const { mutate: finishTFALogin, isLoading: isLoadingFinishTFALogin } = useFinishTFALogin({
        onSuccess: () => {
            finishLoginFlow({ app, postAction });
        },
    });

    const { mutate: sendLoginTFAEmailCode, isLoading: isLoadingSendLoginTFAEmailCode } = useSendLoginTFAEmailCode({
        onSuccess: () => {
            toast.success(messages.codeBeenSent);
        },
    });

    const onEnterCode = useCallback(
        (code: string, isDeviceTrusted = false) => {
            finishTFALogin({ body: { code, stateId, isDeviceTrusted } });
        },
        [finishTFALogin, stateId]
    );

    const onSendCodeViaEmail = useCallback(() => {
        sendLoginTFAEmailCode({ body: { stateId } });
    }, [sendLoginTFAEmailCode, stateId]);

    const onClose = useCallback(() => {
        dispatch(
            showLoginModule({
                innerPageId: pageConfig.store.id,
            })
        );
    }, [dispatch]);

    return (
        <TwoFaActionWizard
            open
            title={messages.title}
            isLoading={isLoadingFinishTFALogin || isLoadingSendLoginTFAEmailCode}
            onEnterAppCode={onEnterCode}
            onEnterBackupCode={onEnterCode}
            onEnterEmailCode={onEnterCode}
            onSendCodeViaEmail={onSendCodeViaEmail}
            isTFAAlternativeEmailEnabled={isTFAAlternativeEmailEnabled}
            isTFABackupCodesEnabled={isTFABackupCodesEnabled}
            isTrustThisDeviceEnabled={isTrustThisDeviceEnabled}
            onClose={onClose}
            disableAutoClose
        />
    );
});

LoginTwoFaModule.displayName = 'LoginTwoFaModule';
